import React, { Component } from "react";
import edit_icon from '../../../images/edit-icon.svg';
import pdfIcon from '../../../images/PDF_file_icon.svg'
class PricingSheetCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: '',
            userName: '',
        }
    }
    componentDidMount() {
        this.handleImageOpen = this.handleImageOpen.bind(this)
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.setState({ userId: Usermeta_Data.split(':')[0], userName: Usermeta_Data.split(':')[1] })
    }
    handleImageOpen(filePath) {
        window.open(filePath, '_blank');
    }
    editSheet(e) {
        e.stopPropagation()
        this.props.editSheet()
    }
    render() {
        return (
            <div className="video-card" onClick={() => {
                this.handleImageOpen(this.props.sheetData?.filePath)
            }}>
                <div className="video-image">
                    <iframe src={this.props.sheetData.filePath}
                        width="100%"
                        height="100%">
                    </iframe>
                    <span className="play-icon"><img src={pdfIcon} alt="Play" /></span>
                    <div className="action-icons">
                        <img src={edit_icon} alt="edit" onClick={this.editSheet.bind(this)} />
                    </div>
                </div>
                <h3>{this.props.sheetData.fileName && this.props.sheetData.fileName.substr(0, 35)} {this.props.sheetData.fileName && this.props.sheetData.fileName.length > 35 ? "\u2026" : ""}</h3>
            </div>
        )
    }
}
export default PricingSheetCard;